import { useState, useEffect, useRef } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";
import Swal from "sweetalert2";

export default function CareerPage() {
  const filters = [
    "All",
    "Article Assistant",
    "Qualified CA",
    "Semi-qualified",
    "Support Roles",
    "Others",
  ];
  const [selectedFilter, setSelectedFilter] = useState("All");

  const [job, setJob] = useState([]);
  const getJobData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/job`
      );
      if (res.status === 200) {
        setJob(res.data.data);
      } else {
        setJob([]);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getJobData();
  }, []);

  const filteredJobs =
    selectedFilter === "All"
      ? job
      : job.filter(
        (item) =>
          item.category?.toLowerCase() === selectedFilter.toLowerCase()
      );

  //        Applicaiton Form
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    job_id: "",
    name: "",
    email: "",
    phone: "",
    role: "",
    experience: "",
    city: "",
    intro: "",
    file: null,
  });

  const handleFormChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const openApplyForm = (jobId, jobTitle) => {
    setFormData((prev) => ({
      ...prev,
      job_id: jobId, // ✅ backend key
      role: jobTitle, // ✅ UI display
    }));
    setShowForm(true);
  };

  const [loader, setLoader] = useState(false);
  const handleApplicationSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoader(true);

      const formDataObj = new FormData();
      Object.keys(formData).forEach((key) => {
        formDataObj.append(key, formData[key]);
      });

      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/job/apply`,
        formDataObj
      );

      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Application Submitted Successfully",
          timer: 1800,
        }).then(() => {
          setShowForm(false);
          setFormData({
            job_id: "",
            name: "",
            email: "",
            phone: "",
            role: "",
            experience: "",
            city: "",
            intro: "",
            file: null,
          });
        });
      }
    } catch (error) {
      if (error.response?.status === 409) {
        Swal.fire({
          icon: "warning",
          title: "Already Applied",
          text: error.response.data.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
        });
      }
    } finally {
      setLoader(false);
    }
  };

  //        Candidate Applicaiton Form
  const [formDataCan, setFormDataCan] = useState({
    name: "",
    email: "",
    phone: "",
    file: null,
  });

  const handleFormChangeCan = (e) => {
    const { name, value, files } = e.target;
    setFormDataCan({
      ...formDataCan,
      [name]: files ? files[0] : value,
    });
  };
  const fileInputRefCan = useRef(null);

  const handleApplicationSubmitCan = async (e) => {
    e.preventDefault();
    try {
      const formDataObjCan = new FormData();
      Object.keys(formDataCan).forEach((key) => {
        formDataObjCan.append(key, formDataCan[key]);
      });

      const res = await axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}/application/store`, formDataObjCan);
      if (res.status === 200) {
        Swal.fire({
          icon: "success",
          title: "Application Submitted Successfully",
          timer: 1800,
        }).then(() => {
          setFormDataCan({
            name: "",
            email: "",
            phone: "",
            file: null,
          });
          // ✅ Clear file input manually
          if (fileInputRefCan.current) {
            fileInputRefCan.current.value = "";
          }
        });
      }
    } catch (error) {
      if (error.response?.status === 409) {
        Swal.fire({
          icon: "warning",
          title: "Already Applied",
          text: error.response.data.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
        });
      }
    }
  };

  return (
    <>
      <Header />

      {/* HERO SECTION */}
      <section
        className="about-hero"
        style={{ backgroundImage: "url('/assets/img/career1.jpg')" }}
      >
        <div className="overlay"></div>
        <div className="about-hero-text">
          <h1>Join Our Team</h1>
          <p>
            Build your career with S D P M & Co. – where passion meets purpose.
          </p>
        </div>
      </section>

      <div className="career-container">
        {/* MAIN SECTION */}
        <div className="hero">
          <h1>Why Join Us</h1>
          <p className="service-text">
            Content Change - A professionally enriching environment with
            meaningful client exposure. We combine rigorous technical work with
            a culture that values learning, mentorship, and long-term career
            development.
          </p>

          {/* <p
            className="highlight intro-link"
          >
            Freshers & experienced professionals welcome. 👉
            <span className="link">Introduce yourself →</span>
          </p> */}
        </div>

        {/* FILTERS */}
        <div className="filters">
          {filters.map((filter) => (
            <button
              key={filter}
              className={selectedFilter === filter ? "active" : ""}
              onClick={() => setSelectedFilter(filter)}
            >
              {filter}
            </button>
          ))}
        </div>

        {/* CAREER CARDS */}
        <div className="container">
          <div className="row">
            {filteredJobs.length > 0 ? (
              filteredJobs.map((data, i) => (
                <div key={i} className="career-card col-md-6 m-3">
                  <h3>{data.title}</h3>
                  <p>Job Type: {data.time}</p>
                  <p>Department: {data.department}</p>
                  <p>Experience: {data.experience}</p>

                  <div
                    dangerouslySetInnerHTML={{ __html: data.description }}
                    style={{ lineHeight: "1.7", fontSize: "16px" }}
                  />

                  <button
                    className="apply-btn"
                    onClick={() => openApplyForm(data.id, data.title)}
                  >
                    Apply now
                  </button>
                </div>
              ))
            ) : (
              /* ✅ PROFESSIONAL EMPTY STATE UI */
              <div className="col-12 text-center no-jobs-ui">
                {/* No Openings SVG */}
                <svg
                  width="96"
                  height="96"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginBottom: "14px" }}
                >
                  {/* Briefcase */}
                  <path
                    d="M3 7H21V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V7Z"
                    stroke="#9CA3AF"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M8 7V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V7"
                    stroke="#9CA3AF"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                  />

                  {/* Handle */}
                  <path d="M3 11H21" stroke="#9CA3AF" strokeWidth="1.5" />

                  {/* Clock circle */}
                  <circle
                    cx="16.5"
                    cy="16.5"
                    r="3.5"
                    stroke="#9CA3AF"
                    strokeWidth="1.5"
                  />

                  {/* Clock hands */}
                  <path
                    d="M16.5 14.5V16.5L17.8 17.3"
                    stroke="#9CA3AF"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>

                <h3>For No Jobs - Opportunities Coming Soon</h3>

                <p
                  style={{
                    maxWidth: "520px",
                    margin: "10px auto",
                    color: "#666",
                  }}
                >
                  There are no openings for this role currently. New positions
                  are posted from time to time — please visit again.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {showForm && (
        <div className="modal-overlay">
          <div className="application-form">
            <button className="close-btn" onClick={() => setShowForm(false)}>
              ✕
            </button>

            <h2>Share Your Details With Us</h2>
            <p>Fill in your details and attach your CV.</p>

            <form onSubmit={handleApplicationSubmit}>
              <input
                name="name"
                placeholder="Full name"
                onChange={handleFormChange}
                required
              />

              <input
                name="email"
                type="email"
                placeholder="Email ID"
                onChange={handleFormChange}
                required
              />

              <input
                name="phone"
                placeholder="Mobile number"
                onChange={handleFormChange}
                required
              />

              <input name="role" value={formData.role} readOnly />

              <input
                name="experience"
                placeholder="Total experience"
                onChange={handleFormChange}
                required
              />

              <input
                name="city"
                placeholder="Current city"
                onChange={handleFormChange}
                required
              />

              <textarea
                name="intro"
                placeholder="Brief introduction"
                onChange={handleFormChange}
                required
              />

              <input
                type="file"
                name="file"
                onChange={handleFormChange}
                required
              />

              <button type="submit" disabled={loader}>
                {loader ? "Submitting..." : "Submit Application"}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* WHAT WE LOOK FOR SECTION */}

      {/* <section className="look-for-section my-2">
        <div className="look-for-header">
          <p className="sub-title">WHAT WE LOOK FOR?</p>
          <h2>People Who Grow With Us</h2>
        </div>

        <div className="look-for-grid">
          <div className="look-card">
            <span className="count">01.</span>
            <h4>Positive Attitude</h4>
            <p>
              Maintain a positive attitude and follow the office culture.
              Embrace the core values & maintain a good team attitude.
            </p>
          </div>

          <div className="look-card">
            <span className="count">02.</span>
            <h4>Leadership Traits</h4>
            <p>
              We welcome those with leadership skills to contribute to the team
              and explore their potential.
            </p>
          </div>

          <div className="look-card">
            <span className="count">03.</span>
            <h4>Excellent Team Player</h4>
            <p>
              Good team spirit and an ability to work closely with other team
              members.
            </p>
          </div>

          <div className="look-card">
            <span className="count">04.</span>
            <h4>Learn and Grow</h4>
            <p>
              Eager to learn further & expand their knowledge. Passion to
              further their career.
            </p>
          </div>

          <div className="look-card">
            <span className="count">05.</span>
            <h4>High Goals</h4>
            <p>
              People who set their goals high and make an effort to achieve
              them.
            </p>
          </div>

          <div className="look-card">
            <span className="count">06.</span>
            <h4>Self-Motivated</h4>
            <p>
              We like self-motivated employees who have a passion for their
              work.
            </p>
          </div>
        </div>
      </section> */}





      {/* EXPERIENCE SECTION */}
      <section className="experience-section">
        <div className="experience-content-only">
          <p className="sub-title">EXPERIENCE THAT MATTERS</p>
          <h2>A Workplace Built for Growth & Excellence</h2>

          <div className="experience-points">
            <ul>
              <li>Our people are our highest priority.</li>
              <li>Performance is recognized and rewarded.</li>
              <li>Continuous learning opportunities.</li>
              <li>Flexibility and autonomy.</li>
              <li>Healthy work-life balance.</li>
            </ul>

            <ul>
              <li>Professional and approachable environment.</li>
              <li>Exposure to evolving regulations.</li>
              <li>Entrepreneurial mindset.</li>
              <li>Opportunities to innovate.</li>
              <li>Strong mentorship.</li>
            </ul>
          </div>
        </div>
      </section>



      {/* FORM */}
      <div className="container my-4">
        <div className="application-form">
          <h2>Share Your Details With Us</h2>
          <p>Fill in your details and attach your CV.</p>

          <form onSubmit={handleApplicationSubmitCan}>
            <input
              name="name"
              placeholder="Full name"
              onChange={handleFormChangeCan}
              value={formDataCan.name}
              required
            />

            <input
              name="email"
              type="email"
              placeholder="Email ID"
              value={formDataCan.email}
              onChange={handleFormChangeCan}
              required
            />

            <input
              name="phone"
              placeholder="Mobile number"
              value={formDataCan.phone}
              onChange={handleFormChangeCan}
              required
            />

            <input type="file" name="file"
              ref={fileInputRefCan}
              onChange={handleFormChangeCan} required />

            {/* ✅ Button class added */}
            <button type="submit" className="apply-btn">
              Submit application
            </button>
          </form>
        </div>
      </div>


      <Footer />
    </>
  );
}
